import { React, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

const ReasonInput = forwardRef((props, ref) => {
  const { value, setValue, className, placeholder, type, disabled } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
	// const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		invalidValue: () => {
			inputRef.current.style.borderColor = '#FF3131';
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = '#E8E8E8';
		}
	}));

	function onClickInput(e) {
		inputRef.current.style.borderColor = '#FF8B48';
	}

	function onChangeInput(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function onFocusInput(e) {
		if (changed) {
			// do nothing
		}
else {
			setValue("");
		}
	}

	function onBlurInput(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = '#E8E8E8';
		if (value === "") {
			// setDefaultPlaceholder(placeholder);
			// inputRef.current.style.borderColor = '#FF3131';
		} 
		else {
			// inputRef.current.style.borderColor = '#E8E8E8';
		}
	}
  return(
    <TopLevelWrapper>
      <Text>사유</Text>
      <Input
        ref={inputRef}
        clickCount={clickCount}
        type={type}
        placeholder={defaultPlaceholder}
        value={value || ''}
        disabled={disabled}
        className={`${className} ${changed ? "changed" : ""}`}
        onClick={onClickInput}
        onChange={onChangeInput}
        onFocus={onFocusInput}
        onBlur={onBlurInput} />
    </TopLevelWrapper>
  )
})

export default ReasonInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 24px 0 0 24px;

  width: 90%;

  gap: 11px;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  white-space: nowrap;
`;

const Input = styled.textarea`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
  
  // width: 317px;
  // width: 309px;
  width: 100%;
  // height: 96px;
  height: 90px;

  // padding: 6px 0 0 8px;
	padding: 6px 8px 6px 8px;

  background-color: ${props => props.theme.subBackground};
  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;

  font-fmaily: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 20.27px;

  color: ${props => props.theme.text};

  outline: none;
  resize: none;

  &::placeholder {
		color: ${props => props.theme.subText};
	}
`;